/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListSalePointDto } from '../../models/api-response-list-sale-point-dto';

export interface GetSalePoints$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  includeArchived?: boolean;
}

export function getSalePoints(http: HttpClient, rootUrl: string, params: GetSalePoints$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListSalePointDto>> {
  const rb = new RequestBuilder(rootUrl, getSalePoints.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('includeArchived', params.includeArchived, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListSalePointDto>;
    })
  );
}

getSalePoints.PATH = '/v1/api/sale-points/list';
